module.exports = __webpack_public_path__ + "dde683344907f00ff687872465c37f9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/news/img1.jpg
// module id = 340
// module chunks = 0